export default __webpack_public_path__ + "static/media/maui.3699dc00.png";